/* global __webpack_public_path__ */

const normalizeAssetCdnUrl = (value) => {
  if (!value || typeof value !== "string") {
    return "";
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return "";
  }

  const withProtocol = /^https?:\/\//i.test(trimmed)
    ? trimmed
    : `https://${trimmed}`;

  return withProtocol.replace(/\/+$/, "");
};

const runtimeConfig = window.runtimeConfig || {};
const assetCdnEnabled =
  runtimeConfig.REACT_APP_ASSET_CDN_ENABLED === true ||
  runtimeConfig.REACT_APP_ASSET_CDN_ENABLED === "true" ||
  runtimeConfig.REACT_APP_ASSET_CDN_ENABLED === "1" ||
  window.__ASSET_CDN_ENABLED__ === true ||
  window.__ASSET_CDN_ENABLED__ === "true" ||
  window.__ASSET_CDN_ENABLED__ === "1";

const assetCdnUrl = normalizeAssetCdnUrl(
  runtimeConfig.REACT_APP_ASSET_CDN_URL ||
  window.__ASSET_CDN_URL__
);

if (assetCdnEnabled && assetCdnUrl) {
  __webpack_public_path__ = `${assetCdnUrl}/`;
  window.__ASSET_CDN_URL__ = assetCdnUrl;
}
